import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { testimonials, TESTIMONIALS_NOTE } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="mx-auto max-w-page px-4 sm:px-6 lg:px-8 py-12 text-center" data-id="element-245" data-mp="3fzdzvmnrkjqe">
      <h2 id="testimonios" className="font-display text-2xl md:text-3xl font-bold uppercase text-ink" data-id="element-246" data-mp="3azt39iw2gngu">
        Lo que dicen quienes ya empezaron
      </h2>
      <ul className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-4" data-id="element-247" data-mp="31zmto83ho7my">
        {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className="flex h-full flex-col items-center rounded-2xl border border-line bg-surface p-5 text-center" data-id="element-248" data-mp="2x1urml94r551" data-mpi={i}>
            <div className="flex gap-0.5" aria-label="5 de 5 estrellas" data-id="element-249" data-mp="v8wuwec8fset">
              {Array.from({
            length: 5
          }).map((_, j) => <StarIcon key={j} size={14} className="fill-gold text-gold" data-id="element-250" data-mp="h5y74a92151i" data-mpi={j} />)}
            </div>
            <blockquote className="mt-3 text-sm leading-relaxed text-ink" data-id="element-251" data-mp="m4rmy9btd84u">
              “{t.quote}”
            </blockquote>
            <footer className="mt-auto pt-4" data-id="element-252" data-mp="78jzn053zqlc">
              <p className="text-sm font-semibold text-ink" data-id="element-253" data-mp="79v99gl8jskd">
                — {t.author} · {t.location}
              </p>
            </footer>
          </Reveal>)}
      </ul>
      <p className="mt-4 text-xs italic text-ink-subtle" data-id="element-254" data-mp="zwxzllfrcwzj">{TESTIMONIALS_NOTE}</p>
    </section>;
}